import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

function dm_c11() {
    if ($('.c11-swiper').length) {
        $('.c11-swiper').each(function () {
            const $container = $(this);
            const $swiperContainer = $container.closest('.container-fluid');
            const $navContainer = $swiperContainer.find('.c11-nav');
            const $counter = $swiperContainer.find('.swiper-counter');
            const prevEl = $('<div class="swiper-button-prev"><div class="btn btn-outline btn-icon icon-left swiper-button-prev"></div></div>');
            const nextEl = $('<div class="swiper-button-next"><div class="btn btn-outline btn-icon icon-right swiper-button-next"></i></div></div>');
            $navContainer.append(prevEl);
            $navContainer.append(nextEl);
            new Swiper(this, {
                modules: [Navigation],
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 20,
                navigation: {
                    nextEl: nextEl[0],
                    prevEl: prevEl[0],
                },
                breakpoints: {
                    1280: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                    },
                    768: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                    },
                    0: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                    },
                },
                on: {
                    init: function (swiperInstance) {
                        const totalSlides = parseInt($counter.data('total'), 10);
                        const slidesPerView = swiperInstance.params.slidesPerView;
                        const totalPages = Math.ceil(totalSlides / slidesPerView);

                        $counter.find('span').eq(0).text(swiperInstance.snapIndex + 1);
                        $counter.find('span').eq(2).text(totalPages);
                    },
                    slideChange: function (swiperInstance) {
                        $counter.find('span').eq(0).text(swiperInstance.snapIndex + 1);
                    },
                    breakpoint: function (swiperInstance) {
                        const totalSlides = parseInt($counter.data('total'), 10);
                        const slidesPerView = swiperInstance.params.slidesPerView;
                        const totalPages = Math.ceil(totalSlides / slidesPerView);

                        $counter.find('span').eq(0).text(swiperInstance.snapIndex + 1);
                        $counter.find('span').eq(2).text(totalPages);
                    }
                },
            });
        });
    }
}

export { dm_c11 };
